import { request } from '@/utils/request';

import type { ApiResponse, WrappedItemsResult, WrappedResult } from './types';

const notesApi = {
  get(params?: cyrian.api.notes.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.notes.Note[]>> {
    return request({
      url: '/notes',
      params,
    });
  },
  create(data: cyrian.api.notes.Params): ApiResponse<WrappedResult<cyrian.api.notes.Note>> {
    return request({
      method: 'post',
      url: '/notes',
      data,
    });
  },
};

export default notesApi;
